import classNames from 'classnames';
import React from 'react';
import { Column, Table } from '../../../components/Table/Table';
import { formatNumber } from '../../../core/helpers';

export interface FeesItem {
  id: number;
  asin: string;
  sku: string;
  name: string;
  purchase_price: number;
  selling_price: number;
  fees: number;
  shipping: number;
  other: number;
  profit: number;
}

interface Props {
  items: FeesItem[];
  setItems: React.Dispatch<React.SetStateAction<FeesItem[]>>;
}

export default function FeesTable({ items, setItems }: Props) {
  const columns: Column<FeesItem>[] = [
    {
      label: 'ASIN',
      field: 'asin',
      maxWidth: '140px',
    },
    {
      label: 'SKU',
      field: 'sku',
      maxWidth: '100px',
    },
    {
      label: 'Name',
      field: 'name',
      formatter: (item) => <div className='text-truncate'>{item.name}</div>,
      maxWidth: '1.15fr',
    },
    {
      label: 'Purchase price',
      field: 'purchase_price',
      formatter: (item) => (
        <div>
          {formatNumber(item.purchase_price / 100, {
            currency: 'eur',
          })}
        </div>
      ),
    },
    {
      label: 'Selling price',
      field: 'selling_price',
      formatter: (item) => (
        <div>
          {formatNumber(item.selling_price / 100, {
            currency: 'eur',
          })}
        </div>
      ),
    },
    {
      label: 'Fees',
      field: 'fees',
      formatter: (item) => (
        <div>
          {formatNumber(item.selling_price / 100, {
            currency: 'eur',
          })}
        </div>
      ),
    },
    {
      label: 'Shipping',
      field: 'shipping',
      formatter: (item) => (
        <div>
          {formatNumber(item.selling_price / 100, {
            currency: 'eur',
          })}
        </div>
      ),
    },
    {
      label: 'Other',
      field: 'other',
      formatter: (item) => (
        <div>
          {formatNumber(item.other / 100, {
            currency: 'eur',
          })}
        </div>
      ),
    },
    {
      label: 'Profit',
      field: 'profit',
      formatter: (item) => (
        <div
          className={classNames({
            'Text--red': item.profit < 100,
          })}
        >
          {formatNumber(item.profit / 100, {
            currency: 'eur',
          })}
        </div>
      ),
    },
  ];

  return (
    <>
      <Table<FeesItem>
        columns={columns}
        data={items}
        className='Table--Inventory'
      />
    </>
  );
}

export const FEES_ITEMS: FeesItem[] = [
  {
    id: 1,
    asin: 'B08XY1VHJX',
    sku: '50365',
    name: 'SOFIA MILANI - Damen',
    purchase_price: 469,
    selling_price: 1469,
    fees: 269,
    shipping: 800,
    other: 0,
    profit: -169,
  },
  {
    id: 2,
    asin: 'B08XY1VHJX',
    sku: '50365',
    name: 'Vintage boots made in France',
    purchase_price: 469,
    selling_price: 1469,
    fees: 500,
    shipping: 450,
    other: 0,
    profit: 50,
  },
  {
    id: 3,
    asin: 'B08XY1VHJX',
    sku: '50365',
    name: 'Armchair for barbershop...',
    purchase_price: 469,
    selling_price: 1469,
    fees: 200,
    shipping: 400,
    other: 100,
    profit: 769,
  },
  {
    id: 4,
    asin: 'B08XY1VHJX',
    sku: '50365',
    name: 'SOFIA MILANI - Damen',
    purchase_price: 469,
    selling_price: 1469,
    fees: 200,
    shipping: 400,
    other: 0,
    profit: 300,
  },
  ...Array(21)
    .fill({
      id: 5,
      asin: 'B08XY1VHJX',
      sku: '50365',
      name: 'Vintage boots made in France',
      purchase_price: 6600,
      selling_price: 9100,
      fees: 1100,
      shipping: 1000,
      other: 0,
      profit: 300,
    })
    .map((v, i) => ({
      ...v,
      id: v.id + i,
    })),
];
export const feesfilterFn = (str: string) => (c: FeesItem) => {
  return ['name', 'asin', 'sku'].some((f) =>
    String(c[f as keyof FeesItem])
      .toLowerCase()
      .includes(str.toLowerCase().trim())
  );
};
